import React from 'react';
import { motion } from 'framer-motion';
export function Mechanism() {
  return <section className="py-20 md:py-28 px-4 bg-brand-darker border-y border-brand-gray relative overflow-hidden" data-id="element-106">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-107">
        <motion.div className="w-full md:w-1/2" initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-108">
          <div className="relative flex justify-center" data-id="element-109">
            <img src="https://cdn.magicpatterns.com/uploads/btVEywnEErmj7scvJtDTSp/ChatGPT_Image_13_jun_2026,_19_53_13.png" alt="Libro El Protocolo Alpha" className="w-full max-w-md h-auto object-contain drop-shadow-[0_0_45px_rgba(255,81,0,0.35)]" data-id="element-110" />
          </div>
        </motion.div>

        <motion.div className="w-full md:w-1/2" initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-111">
          <span className="inline-block text-brand-orange font-bold tracking-widest text-xs md:text-sm uppercase mb-4" data-id="element-112">
            — El Mecanismo Único —
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white uppercase mb-6 leading-tight" data-id="element-113">
            Recalibración de{' '}
            <span className="text-brand-orange" data-id="element-114">Dopamina y Testosterona</span>
          </h2>
          <div className="space-y-6 text-lg text-brand-text leading-relaxed" data-id="element-115">
            <p data-id="element-116">
              La mayoría de los hombres intentan arreglar su energía con café o
              suplementos caros.
            </p>
            <p className="font-medium text-white border-l-4 border-brand-orange pl-4" data-id="element-117">
              El Protocolo Alpha ataca la raíz: la desensibilización
              neuro-hormonal.
            </p>
            <p data-id="element-118">
              Reajustamos tus receptores para que tu cuerpo produzca energía de
              forma natural, devolviéndote el impulso biológico que creías haber
              perdido para siempre.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}